export default __webpack_public_path__ + "static/req-f02a60a0d57224368fc5dadba8de3861.pdf";